import { render } from "./AudioTranscriberFull.vue?vue&type=template&id=0dd730e3"
import script from "./AudioTranscriberFull.vue?vue&type=script&lang=js"
export * from "./AudioTranscriberFull.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__